export default `:host {
  height: 100%;
}

.ids-week-view {
  display: flex;
  background-color: var(--ids-week-view-color-background);
  color: var(--ids-week-view-color-text);
  border: 1px solid var(--ids-week-view-color-border);
  flex-direction: column;
  overflow: hidden;
  max-height: calc(100dvh - 25px);
}
.ids-week-view .week-view-table-header th {
  background-clip: padding-box;
  border-top: 0;
  height: 24px;
  line-height: 24px;
  text-align: left;
  z-index: 3;
}
.ids-week-view .week-view-table-header .week-view-header-wrapper {
  padding: 0 5px;
  text-align: center;
}
.ids-week-view .week-view-table-header .week-view-header-wrapper .week-view-header-day-of-week {
  line-height: var(--ids-week-view-row-height);
}
.ids-week-view .week-view-table-header .week-view-header-wrapper.is-day-view .week-view-header-day-of-week.is-emphasis {
  line-height: 40px;
}
.ids-week-view .week-view-table-header .week-view-all-day-wrapper {
  position: relative;
  box-sizing: border-box;
  border-color: var(--ids-week-view-color-border);
  height: 44px;
  text-transform: unset;
  border-top-width: 1px;
  border-top-style: solid;
}
.ids-week-view .week-view-table-header th:nth-child(1) .week-view-all-day-wrapper {
  border-top-color: var(--ids-color-transparent);
  padding: 5px;
}
.ids-week-view .week-view-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.ids-week-view .week-view-table .week-view-allday-row {
  height: 40px;
}
.ids-week-view .week-view-table .week-view-hour-row,
.ids-week-view .week-view-table .week-view-half-hour-row {
  height: var(--ids-week-view-row-height);
}
.ids-week-view .week-view-table th,
.ids-week-view .week-view-table td {
  border-bottom: 1px solid;
  border-color: var(--ids-week-view-color-border);
  padding: 0;
  height: var(--ids-week-view-row-height);
}
.ids-week-view .week-view-table th:nth-child(1) {
  width: 60px;
}
.ids-week-view .week-view-table tr td:nth-child(1) .week-view-cell-wrapper {
  padding: 0 5px;
}
.ids-week-view .week-view-table tr:nth-child(odd) td {
  border-bottom: 1px solid var(--ids-week-view-row-odd-color-border);
}
.ids-week-view .week-view-table th:not(:last-child),
.ids-week-view .week-view-table td:not(:last-child) {
  border-right-width: 1px;
  border-right-style: solid;
}
.ids-week-view .week-view-header-wrapper.is-today {
  color: var(--ids-week-view-today-color);
  box-shadow: 0 4px 0 0 var(--ids-week-view-today-color);
}
.ids-week-view .week-view-container {
  background-color: var(--ids-week-view-color-background);
  overflow: auto;
}
.ids-week-view .week-view-container th {
  background-color: var(--ids-week-view-header-color-background);
  position: sticky;
  top: 0;
  z-index: 3;
}
.ids-week-view .week-view-cell-wrapper {
  position: relative;
  padding: 0;
  height: var(--ids-week-view-row-height);
  min-width: 50px;
}
.ids-week-view .week-view-time-marker {
  display: block;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  border: 1px solid var(--ids-week-view-time-marker-color);
  height: 1px;
  margin-top: -2px;
  top: var(--timeline-shift);
}

ids-toolbar ids-menu-button[menu=view-picker] {
  margin-inline-end: 8px;
}

:host([dir=rtl]) .week-view-all-day-wrapper {
  text-align: right;
}
:host([dir=rtl]) .ids-week-view .week-view-table th:not(:first-child),
:host([dir=rtl]) .ids-week-view .week-view-table td:not(:first-child) {
  border-right-width: 1px;
  border-right-style: solid;
}
:host([dir=rtl]) .ids-week-view .week-view-table th:first-child,
:host([dir=rtl]) .ids-week-view .week-view-table td:first-child {
  border-right-width: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
